/* eslint-disable @typescript-eslint/naming-convention */

import { styled } from '@mui/material/styles';
import { Toolbar } from '@mui/material';
import { appBar } from '../../const/componentSize';

// ツールバーのスタイル
export const StyledToolbar = styled(Toolbar)(() => ({
	'@media screen': {
		minHeight: appBar.height,
	},
}));
